<template>
  <div class="tw:h-[50px] tw:px-4 tw:flex tw:shrink-0 tw:items-center tw:border-b tw:gap-4">
    <QuickConversationSiaAvatar />

    <span>Chat with {{ userDisplayName }}</span>

    <CustomTooltip>
      <template #content>
        This is a trained AI assistant to provide customer service and sales support.
        AI can make mistakes.
        Learn more about Dubb Sia <a href="https://dubb.com/features/sia" target="_blank">here</a>.
      </template>
    </CustomTooltip>
  </div>
</template>

<script setup>
import CustomTooltip from '@/components/custom-tooltip.vue'
import QuickConversationSiaAvatar from './quick-conversation-sia-avatar.vue'
import { useQuickConversation } from './use-quick-conversation.js'

const { userDisplayName } = useQuickConversation()
</script>
